const serverConfig = {
  // FIXME: theoretically, this should always be there, but probably a good idea to account for null anyway
  // eslint-disable-next-line no-unsafe-optional-chaining
  timestampOffset: window?.SERVER_DATA?.serverTime - Date.now() || 0,
}

export default serverConfig
